import { DEFAULT_TAB, EMAILING_TABS } from "./EmailingLayout.constants";

export const getTabByPath = (path: string) => {
  const tab = EMAILING_TABS.find((tab) => tab.path === path);

  return tab ?? DEFAULT_TAB;
};
